import axios from 'axios'

export default {
    namespaced: true,
    async create(model) {
        return axios.post(`warehouse`, model)
    },
    async fetchById(id) {
        return axios.get(`warehouse/${id}`)
    },
    async fetch(query, page) {
        return axios.get(`warehouse?q=${query}&page=${page}`)
    },
    async update(id, model) {
        return axios.put(`warehouse/${id}`, model)
    },
    async delete(id) {
        return axios.delete(`warehouse/${id}`)
    },
}
